import { render, staticRenderFns } from "./CertificateCheck.vue?vue&type=template&id=527d6d41"
import script from "./CertificateCheck.vue?vue&type=script&lang=js"
export * from "./CertificateCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports